import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Toasty } from '../../models/toasty.interface';
import { IconsModule } from '../../core/modules/icons.module';
import { ToastyTypes } from '../../constants/toasty-types.enum';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'xos-toasty',
    imports: [IconsModule, CommonModule],
    templateUrl: './toasty.component.html',
    styleUrl: './toasty.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class ToastyComponent {
  @Input() toasty!: Toasty;

  get icon(): string {
    switch (this.toasty.type) {
      case ToastyTypes.SUCCESS:
        return 'check';
      case ToastyTypes.ERROR:
        return 'x';
      case ToastyTypes.WARNING:
        return 'alert-triangle';
      case ToastyTypes.INFO:
        return 'info';
      default:
        return 'info';
    }
  }

  get classes() {
    switch (this.toasty.type) {
      case ToastyTypes.SUCCESS:
        return {'success': true };
      case ToastyTypes.ERROR:
        return {'error': true };
      case ToastyTypes.WARNING:
        return {'warning': true };
      case ToastyTypes.INFO:
        return {'info': true };
      default:
        return {'info': true };
    }
  }
}
